import { Link } from 'shared/components/Link';
import Layout from '../../components/mainPage/Layout';
import { AppRoute } from "../../constants";
import SksuClient from "../../images/systemComponents/SksuClient.svg";
import { ZoomImageContainer } from 'shared/components/Parameters';
export const Page = () => {
  return (
    <Layout>
      <div className="container">
        <div className="article-container w-100">
          <h1 className="mb-4 ">
            СКСУ Клиент
          </h1>
          <p>
            СКСУ Клиент в SCADA NPT Expert — это клиент внутреннего протокола для взаимодействия между SCADA NPT и <Link className="text-links" to={`/${AppRoute.SKSU}`}>программным обеспечением СКСУ</Link> (ПО СКСУ).
          </p>
          <div style={{ float: 'right' }}>
            <div style={{ maxWidth: '500px' }}>
              <ZoomImageContainer
                image={SksuClient}
              />
            </div>
          </div>
          <div>
            <p>Использование сервера станционного контроллера связи и управления (СКСУ) в качестве промежуточного звена между оборудованием подстанции и SCADA дает ряд технических и эксплуатационных преимуществ:</p>
            <ul className="mb-4 description__list">
              <li className="mb-1 description__number-li"><b>Интеграция разнородного оборудования (Концентрация данных)</b>
                <ul>
                  <li>СКСУ выполняет роль шлюза-концентратора. Он <a href={`/${AppRoute.IntegratedDevices}`} className="text-links"> опрашивает устройства </a>  нижнего уровня (микропроцессорные терминалы РЗА, счетчики, датчики), работающие по разным интерфейсам (последовательным (RS-232, RS-422 и RS-485), Ethernet (RJ45, SFP, SFP+, QSFP) и т.д.) и протоколам (ModbusRTU, ModbusTCP, МЭК 60870-5-101/103, МЭК 61850 и т.д.), и передает агрегированные данные в SCADA по внутреннему протоколу (SCADA NPT) или по стандартным протоколам, таким как МЭК 60870-5-104 или МЭК 61850.</li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Снижение нагрузки на сервер SCADA</b>
                <ul>
                  <li>Контроллер фильтрует «дребезг» сигналов, выполняет масштабирование данных и логическую обработку на месте, отправляя на верхний уровень только значимые изменения.</li>
                  <li>SCADA получает не «сырой» поток данных от каждого датчика, а структурированную информацию от сервера СКСУ. </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Повышение надежности и живучести системы</b>
                <ul>
                  <li>При потере связи с центральным сервером SCADA, станционный контроллер продолжает собирать данные и вести локальный архив (буферизацию) событий, которые будут переданы после восстановления связи.</li>
                  <li>СКСУ может поддерживать работу местных панелей отображения (HMI) на подстанции, позволяя персоналу контролировать объект даже при отказе внешних каналов связи.</li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Обеспечение информационной безопасности</b>
                <ul>
                  <li>Сервер связи выступает в роли «демилитаризованной зоны» (DMZ). Он разграничивает технологическую сеть подстанции и внешние сети передачи данных, реализуя функции шифрования, аутентификации и контроля доступа, что критично для объектов энергетики
                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Оптимизация инженерных работ</b>
                <ul>
                  <li>Настройка обмена данными с диспетчерским центром упрощается, так как конфигурация описывается один раз на уровне контроллера связи.</li>
                  <li>СКСУ позволяет проверять состояние всех подключенных к нему устройств РЗА, контроллеров присоединения, приборов учета др. устройств, локализуя неисправности. </li>
                </ul>
              </li>
            </ul>
          </div>
          <div style={{ clear: 'both' }}></div>
        </div>
      </div>
    </Layout >

  );
};

export const meta = {
  title: 'СКСУ Клиент',
  description: ' СКСУ Клиент в SCADA NPT Expert — это клиент внутреннего протокола для взаимодействия между SCADA NPT и программным обеспечением СКСУ (ПО СКСУ).'
}